const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/** Same window as Sell Dashboard default revenue cards (Jan prior year → current month). */
export const getSellDashboardRevenueVars = (referenceDate = new Date()) => ({
  startYear: referenceDate.getFullYear() - 1,
  endYear: referenceDate.getFullYear(),
  startMonth: 'January',
  endMonth: MONTH_NAMES[referenceDate.getMonth()],
});

export const getDashboardAlignedRevenueVars = (
  period: string,
  startDate: string,
  endDate: string,
) => {
  const now = new Date();

  if (period === 'All') {
    return getSellDashboardRevenueVars(now);
  }

  if (period === 'YTD') {
    return {
      startYear: now.getFullYear(),
      endYear: now.getFullYear(),
      startMonth: 'January',
      endMonth: MONTH_NAMES[now.getMonth()],
    };
  }

  const parsedStart = new Date(startDate);
  const parsedEnd = new Date(endDate);
  const safeStart = Number.isNaN(parsedStart.getTime()) ? now : parsedStart;
  const safeEnd = Number.isNaN(parsedEnd.getTime()) ? now : parsedEnd;

  return {
    startYear: safeStart.getFullYear(),
    endYear: safeEnd.getFullYear(),
    startMonth: MONTH_NAMES[safeStart.getMonth()],
    endMonth: MONTH_NAMES[safeEnd.getMonth()],
  };
};
